export const clarityProjectIds: Record<string, string> = {
  // PROD
  "vhp.heala.io": import.meta.env.VITE_APP_CLARITY_PROD_VHP, // DEFAULT PROD
  "hmo.heala.io": import.meta.env.VITE_APP_CLARITY_PROD_HMO, // HMO PROD
  "hospital.heala.io": import.meta.env.VITE_APP_CLARITY_PROD_HOSPITAL, // HOSPITAL PROD
  "doctor-direct.heala.io": import.meta.env.VITE_APP_CLARITY_PROD_DOCTOR, // DOCTOR PROD
  "telemedicine.leadwayhealth.com": import.meta.env.VITE_APP_CLARITY_PROD_HMO, // LEADWAY (HMO PROD)

  // STAGING
  "staging-vhp.heala.io": import.meta.env.VITE_APP_CLARITY_STAGING_VHP, // DEFAULT STAGING
  "hmo-staging.heala.io": import.meta.env.VITE_APP_CLARITY_STAGING_HMO, // HMO STAGING
  "hospital-staging.heala.io": import.meta.env
    .VITE_APP_CLARITY_STAGING_HOSPITAL, // HOSPITAL STAGING
  "doctor-direct-staging.heala.io": import.meta.env
    .VITE_APP_CLARITY_STAGING_DOCTOR, // DOCTOR STAGING
};
